import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class NumberingShouldBeActive extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.numbering-should-be-active');
    }
}
